export enum LoadingMessageEnum {
    Message = 'Loading...',
}